import { SVGProps } from 'react'

export const CartIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M4 5H4.98511C5.17066 5 5.26343 5 5.33809 5.03393C5.40389 5.06383 5.45964 5.11192 5.49871 5.17246C5.54305 5.24116 5.55617 5.33249 5.58241 5.51515L5.93938 8M5.93938 8L6.73272 13.7986C6.83339 14.5344 6.88373 14.9023 7.06063 15.1793C7.21651 15.4233 7.43998 15.6173 7.70416 15.738C8.00396 15.875 8.37735 15.875 9.12414 15.875H15.5785C16.2894 15.875 16.6448 15.875 16.9353 15.7478C17.1914 15.6357 17.4111 15.4549 17.5698 15.2257C17.7498 14.9657 17.8163 14.6185 17.9493 13.9241L18.9476 8.71227C18.9944 8.46786 19.0179 8.34565 18.9839 8.25012C18.9542 8.16633 18.8954 8.09576 18.8182 8.05101C18.7302 8 18.6051 8 18.3549 8H5.93938ZM10.0336 19.25C10.0336 19.6642 9.69595 20 9.27942 20C8.86288 20 8.52522 19.6642 8.52522 19.25C8.52522 18.8358 8.86288 18.5 9.27942 18.5C9.69595 18.5 10.0336 18.8358 10.0336 19.25ZM16.0672 19.25C16.0672 19.6642 15.7296 20 15.313 20C14.8965 20 14.5588 19.6642 14.5588 19.25C14.5588 18.8358 14.8965 18.5 15.313 18.5C15.7296 18.5 16.0672 18.8358 16.0672 19.25Z"
				stroke="white"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
